<script setup lang="ts">

import { AppText } from '@shared/ui/typography'
import { AppTable, AppTd, AppTh, AppTr } from '@shared/ui/tables'
import { LinkTextPrimary } from '@shared/ui/links'

import ApiTokenActions from './ApiTokenActions.vue'
import { useTableApiTokens } from '../../model/api-tokens/table-api-tokens.hook'

defineOptions({
  name: 'TableApiTokens',
})

const {
  tokens,
  isLoading,
  hasTokens,
  meta,
  formatDateTime,
  getUserName,
  getUserHref,
  isExpired,
  openEditModal,
  setChangePage,
  setChangePerPage,
} = useTableApiTokens()
</script>

<template>
  <div class="table-api-tokens">
    <AppTable
      class="rounded-table"
      :meta="meta"
      :loading="isLoading"
      @change:page="setChangePage"
      @change:per-page="setChangePerPage"
    >
      <template #head>
        <AppTr>
          <AppTh class="text-center table-api-tokens__id-cell">
            <AppText
              name="body1-medium"
              color="slate-900"
            >
              #
            </AppText>
          </AppTh>
          <AppTh>
            <AppText
              name="body1-medium"
              color="slate-900"
            >
              Name
            </AppText>
          </AppTh>
          <AppTh>
            <AppText
              name="body1-medium"
              color="slate-900"
            >
              User
            </AppText>
          </AppTh>
          <AppTh>
            <AppText
              name="body1-medium"
              color="slate-900"
            >
              Last used
            </AppText>
          </AppTh>
          <AppTh>
            <AppText
              name="body1-medium"
              color="slate-900"
            >
              Expires
            </AppText>
          </AppTh>
          <AppTh>
            <AppText
              name="body1-medium"
              color="slate-900"
            >
              Created
            </AppText>
          </AppTh>
          <AppTh class="table-api-tokens__actions-cell" />
        </AppTr>
      </template>

      <template
        v-if="hasTokens"
        #body
      >
        <AppTr
          v-for="token in tokens"
          :key="token.id"
        >
          <AppTd class="medium text-center table-api-tokens__id-cell">
            <button
              type="button"
              class="table-api-tokens__cell-link"
              :aria-label="`Edit token ${token.name}`"
              @click="openEditModal(token)"
            >
              <AppText
                name="body1"
                color="blue-600"
              >
                {{ token.id }}
              </AppText>
            </button>
          </AppTd>
          <AppTd class="medium">
            <button
              type="button"
              class="table-api-tokens__cell-link"
              :aria-label="`Edit token ${token.name}`"
              @click="openEditModal(token)"
            >
              <AppText
                name="body1"
                color="blue-600"
              >
                {{ token.name }}
              </AppText>
            </button>
          </AppTd>
          <AppTd class="medium">
            <LinkTextPrimary
              v-if="token.user"
              :href="getUserHref(token)"
              target="_blank"
            >
              {{ getUserName(token) }}
            </LinkTextPrimary>
            <AppText
              v-else
              name="body1"
              color="slate-900"
            >
              —
            </AppText>
          </AppTd>
          <AppTd class="medium table-api-tokens__date-cell">
            <AppText
              name="body1"
              color="slate-900"
            >
              {{ formatDateTime(token.last_used_at) }}
            </AppText>
          </AppTd>
          <AppTd class="medium table-api-tokens__date-cell">
            <AppText
              name="body1"
              :color="isExpired(token) ? 'red-600' : 'slate-900'"
            >
              {{ formatDateTime(token.expires_at) }}
            </AppText>
          </AppTd>
          <AppTd class="medium table-api-tokens__date-cell">
            <AppText
              name="body1"
              color="slate-900"
            >
              {{ formatDateTime(token.created_at) }}
            </AppText>
          </AppTd>
          <AppTd class="zero-padding table-api-tokens__actions-cell">
            <ApiTokenActions :token="token" />
          </AppTd>
        </AppTr>
      </template>
    </AppTable>
  </div>
</template>

<style scoped lang="scss" src="./TableApiTokens.scss" />
